var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-708.000000, -566.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(213.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-outline",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,22 L9,22 C8.44771525,22 8,21.5522847 8,21 L8,14.8 L6,14.8 C5.44771525,14.8 5,14.3522847 5,13.8 L5,10.2 C5,9.64771525 5.44771525,9.2 6,9.2 L8,9.2 L8,7.5 C8.14592611,4.32802978 10.8273342,1.87007237 14,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,6.6 C18,7.15228475 17.5522847,7.6 17,7.6 L14,7.6 L14,9.2 L17,9.2 C17.313008,9.19762843 17.6090686,9.34195795 17.8,9.59 C17.9888544,9.84180584 18.048132,10.167833 17.96,10.47 L16.96,14.07 C16.8354894,14.5152375 16.4220038,14.817082 15.96,14.8 L14,14.8 L14,21 C14,21.5522847 13.5522847,22 13,22 Z M10,20 L12,20 L12,13.8 C12,13.2477153 12.4477153,12.8 13,12.8 L15.24,12.8 L15.68,11.2 L13,11.2 C12.4477153,11.2 12,10.7522847 12,10.2 L12,7.5 C12.0533326,6.43466631 12.933333,5.59866587 14,5.6 L16,5.6 L16,4 L14,4 C11.9330581,3.87407088 10.1495581,5.43463334 10,7.5 L10,10.2 C10,10.7522847 9.55228475,11.2 9,11.2 L7,11.2 L7,12.8 L9,12.8 C9.55228475,12.8 10,13.2477153 10,13.8 L10,20 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/Share-facebook.0fa85e1439861bf11643deca5c5c55d1.svg";
export { ForwardRef as ReactComponent };